// src/utils/googleOAuth.ts
// @dx service

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const REDIRECT_URI = `${window.location.origin}/google-callback`;

// Request all scopes the app uses upfront so the user grants everything at once
const ALL_SCOPES = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
  'https://www.googleapis.com/auth/drive',
  'https://www.googleapis.com/auth/documents',
  'https://www.googleapis.com/auth/gmail.send',
  'https://www.googleapis.com/auth/gmail.compose',
  'https://www.googleapis.com/auth/spreadsheets.readonly',
  'https://www.googleapis.com/auth/chat.messages.create',
];

const OAUTH_STATE_KEY = 'googleOAuthState';

// CSRF binding: the callback only exchanges a code when the redirect carries
// the state this browser session generated here.
export const generateOAuthState = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const state = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  sessionStorage.setItem(OAUTH_STATE_KEY, state);
  return state;
};

// One-time use: the stored state is cleared even on mismatch, so a value can
// never be replayed against a later callback.
export const consumeOAuthState = (returnedState: string | null): boolean => {
  const storedState = sessionStorage.getItem(OAUTH_STATE_KEY);
  sessionStorage.removeItem(OAUTH_STATE_KEY);
  return !!storedState && !!returnedState && storedState === returnedState;
};

export const initiateGoogleOAuth = (extraScopes?: string[]) => {
  const scopes = extraScopes ? [...ALL_SCOPES, ...extraScopes] : ALL_SCOPES;
  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    response_type: 'code',
    scope: scopes.join(' '),
    access_type: 'offline',
    prompt: 'consent select_account',
    state: generateOAuthState(),
  })}`;

  window.location.href = authUrl;
};